import React from 'react';
import { DENIED, GRANTED_ON_SIGN_IN } from '../../../../general/js/api/endeavor/constants/api-constants';
import '../../scss/video-cover-image.scss';
import Oauth from '../../../sso/components/oauth';

export const AccessDeniedView = ({ accessLevel }) => {
    const handleSignIn = () => {
        try {
            Oauth.federatedSignIn();
        } catch (error) {
            console.error(error);
        }
    };

    const handleUpgrade = () => {
        try {
            Oauth.mastercardUpgrade();
        } catch (error) {
            console.error(error);
        }
    };

    switch (accessLevel) {
        case GRANTED_ON_SIGN_IN:
            return <span
                onClick={handleSignIn}
                className="btn"
            >
        Sign In To Watch
            </span>;
        case DENIED:
            return <span
                onClick={handleUpgrade}
                className="btn"
            >
        Upgrade To Watch
            </span>;
        default: return null;
    }
};
